import TranslationText from '@Components/Utilities/TranslationText';

const BlogArticleTags = (props) => {
    return (
        <div className='blog-list-right-menu'>
            <div className='blog-list-right-menu-header'>
                <i className='fas fa-tags' aria-hidden='true' /> &nbsp; <TranslationText tKey='sandhills.tags' />
            </div>
            <div className='blog-list-right-menu-tags'>
                {props.Tags && props.Tags.length > 0 && props.Tags.map((tag, index) =>
                    tag.LinkText &&
                        <a key={index} className='article-tag' itemProp='keywords' href={tag.LinkUrl} dangerouslySetInnerHTML={{ __html: tag.LinkText }} />)}
            </div>
        </div>
    );
};

export default BlogArticleTags;